// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textinput-ctn.fullsize {\n  width: 97%;\n  margin: 1%;\n  height: 30px;\n}\n.textinput-ctn.fullsize select {\n  height: 30px;\n  font-size: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
